const API_URL = () => {
	if (process.env === "production") {
		return process.env.REACT_APP_API_URL;
	} else {
		return process.env.REACT_APP_API_LOCAL_URL;
	}
};

export default API_URL;
